// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3fvEY","box":"WorkspacesBox_box__3yMu6","node":"WorkspacesBox_node__11FHq"};